import { useState } from 'react';
import { Button, Modal } from 'antd';
import YouTube from 'react-youtube';

const opts = {
    height: '400',
    width: '100%',
    playerVars: {
        autoplay: 0,
    }
};

export default function PoupVideo({id}: {id: string}) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };


    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <Button type="primary" onClick={showModal}>
                Xem video
            </Button>
            {
                isModalOpen &&
                <Modal
                    title="View"
                    open={isModalOpen}
                    onCancel={handleCancel}
                    footer={null}
                    width={800}
                >
                    <YouTube videoId={id} opts={opts}/>
                </Modal>
            }
        </>
    );
};